export const MIN_VISIBLE_COUNT = 1
